import { render, staticRenderFns } from "./BaseDeleteAssociationResourceItemDialog.vue?vue&type=template&id=fff4fc64"
import script from "./BaseDeleteAssociationResourceItemDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDeleteAssociationResourceItemDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports